/**
 * pickType Normalizr Schema
 */

import { schema } from 'normalizr';

const pickType = new schema.Entity('pickTypes');

export default pickType;
